import { Routes, Route } from "react-router-dom";
import { NotFound } from "../components/common";
import Home from "../pages/Professor/Home";
import Detail from "../pages/Professor/Detail";
import Edit from "../pages/Professor/Edit";

const Professor = () => {
  return (
    <div className="Professor">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:id" element={<Detail />} />
        <Route path="/:id/edit" element={<Edit />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default Professor;
